import { gql } from '@apollo/client';

export const DELETE_COURSE_CERTIFICATE = gql`
mutation($input: DeleteCourseCertificateInput!) { 
    result: deleteCourseCertificate(input: $input) { 
        affectedRows
    }
}
`;